<template>
  <div class="home_content" @click="hidDia">
    <img src="../../assets/LinkDo.png" alt="" class="home_top_logo">
    <div class="center_area">
      <div class="search_content" >
        <img src="../../assets/LinkDo.png" alt="" class="home_center_logo">
        <div class="home_title">中国海关数字清关药品中日专线</div>
        <el-input placeholder="请输入运单号" @keyup.enter.native="toGetLogisticsTraceByNo" v-model.trim="keyword" :class="timelineList&&timelineList.length?'marginTop60':'marginTop120'" >
          <template slot="suffix">
            <div class="searchButton" @click="toGetLogisticsTraceByNo">查单</div>
          </template>
        </el-input>
        
        <div id="timeline" class="timeline_list" v-if="timelineList&&timelineList.length" @click.stop>
        <div @click="copyElementText" class="copy_button">
          <i class="el-icon-document-copy" ></i>
        </div>
        <el-timeline style="margin-top: 10px;" >
          <el-timeline-item
            v-for="(activity, index) in timelineList"
            :key="index"
            color="#973529"
            :timestamp="activity.time">
            {{activity.desc}}
          </el-timeline-item>
        </el-timeline>
      </div>
      </div>
      
    </div>
    <div class="bottom_area">
      <div class="support">
        <img src="../../assets/LinkDo.png" alt="" class="home_bottom_logo">
        <div class="contact_us">联系我们</div>
       <!-- <div class="contact_us_icon">
          <img src="../../assets/contact1.png" alt="" class="icon">
          <img src="../../assets/contact2.png" alt="" class="icon">
          <img src="../../assets/contact3.png" alt="" class="icon">
          <img src="../../assets/contact4.png" alt="" class="icon">
        </div> -->
        <div class="filing">
          <div class="filing_item">
            ©2021-2025 版权所有 杭州喜相逢跨境电子商务有限公司
          </div>
          <div class="filing_item hover_point" @click="jumpIn('https://beian.miit.gov.cn/#/Integrated/index')">浙ICP备2025189882号</div>
          <!--<div class="filing_item hover_point" @click="jumpIn('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049202000346')">
            <img src="../../assets/police.png" alt="">
            <span>粤公网安备 44049202000346号</span></div>-->
      </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { getLogisticsTraceByNo,getSystemDictDict,getTraceByWaybillId } from '@/api/base';
import { getDictName } from '@/utils/commonMethod';
export default {
  name: 'HomePage',
  data() {
    return {
      keyword:'',
      timelineList:[],
      dictList:[],
      traceNo:'',
    }
  },
  methods: {
    getDictName,
    jumpIn(url){
      window.open(url)
    },
    toGetLogisticsTraceByNo(){
      this.timelineList = [];
      if(!this.keyword){
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '查询中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.traceNo = this.keyword;
      getTraceByWaybillId(this.keyword).then(res=>{
		
          if(res.data){
            // this.timelineList = res.data.dataList.map(item=>{
            //   return {
            //     ...item,
            //   }
            // });
			this.timelineList=res.data;
          }else{
            this.$message.warning('暂无该运单号物流信息')
          }
        loading.close();
      }).catch(err=>{loading.close();})
    },
    toGetSystemDictDict(){
      getSystemDictDict({}).then(res=>{
        console.log(res,'res')
      }).catch(err=>{})
    },
    hidDia(event){
      if (event.target.closest('.copy_button')) {
        console.log('复制按钮被点击，不执行 hidDia');
        return;
      }
      this.timelineList = [];
    },
    copyElementText() {
      console.log(1)
      const element = document.getElementById('timeline');
      if (!element) {
        console.error('未找到指定的元素');
        return;
      }
      let text = element.innerText || element.textContent;
      text = `${this.traceNo}\n${text}`
      console.log(navigator.clipboard)
      if(navigator.clipboard){
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message.success('已复制到剪贴板')
          },
          (err) => {
            this.$message.warning('无法复制文案')
          }
        );
      }else{
        this.fallbackCopyText(text)
      }
      
    },
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制到剪贴板');
      } catch (err) {
        this.$message.warning('无法复制文案');
      }
      document.body.removeChild(textarea);
    }
  },
  created() {
    // this.toGetSystemDictDict();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-timeline-item__tail{
  border-left: 2px solid #973529;
}
.copy_button{
  position: fixed;
  bottom: 5px;
  right: 10px;
  color: #919398;
  cursor: pointer;
  z-index: 999999;
}
.home_content{
  position: relative;
  background-image:url('../../assets/home_bac.png');
  background-repeat: no-repeat;
  background-size: cover;
  .min-h-screen{
   min-height: 100vh;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
  .home_top_logo{
    position: absolute;
    width: 156px;
    height: 26px;
    left: 30px;
    top: 30px;
  }
  .center_area{
    width: 100%;
    height: calc(100vh - 280px);
    display: flex;
    align-items: center;
    justify-content: center;
    // background-image:url('../../assets/home_bac.png');
    // background-repeat: no-repeat;
    .timeline_list{
      z-index: 99;
      margin-top: 8px;
      // position: absolute;
      height: calc((120vh - 300px - 280px));
      width: 500px;
      // bottom: 5px;
      background: #FFFFFF;
      border-radius: 10px;
      overflow-y: auto;
      box-shadow: 0px 20px 30px 1px rgba(82,0,0,0.1);
      

    }
  }
  
  .search_content{
    position: relative;
    margin-top: 26px;
    min-width: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transform: translateZ(0);
    .home_center_logo{
      height: 65px;
      width: 382px;
    }
    .home_title{
      height: 20px;
      font-size: 20px;
      font-weight: bold;
      color: #383333;
      margin-top: 30px;
    }
  }
  .searchButton{
    width: 96px;
    height: 44px;
    background: linear-gradient(315deg, #A42B21 0%, #C63E33 100%);
    border-radius: 12px 12px 12px 12px;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 44px;
    margin-top: 4px;
    cursor: pointer;
  }
  .bottom_area{
    width: 100%;
    height: 280px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    // align-items: center;
    .support{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 65px;
      .home_bottom_logo{
        height: 32px;
        width: 184px;
      }
      .contact_us{
        font-size: 14px;
        font-weight: 400;
        color: #6C6767;
        margin-top: 30px;
      }
      .contact_us_icon{
        display: flex;
        margin-top: 10px;
        .icon{
          width: 32px;
          height: 32px;
          margin: 0 8px;
        }
      }
    }
    .filing{
      display: flex;
      margin-top: auto;
      .filing_item{
        display: flex;
        padding: 10px;
        font-size: 12px;
        font-weight: 400;
        color: #9D9898;
        margin:20px 0px 10px 0px;
        align-items: center;
      }
    }
  }
  .hover_point{
    cursor: pointer;
  }
  .marginTop120{
    margin-top: 120px;
  }
  .marginTop60{
    margin-top: 60px;
  }
}
::v-deep .el-input{
  height: 52px;
  background: #FFFFFF;
  box-shadow: 0px 20px 30px 1px rgba(82,0,0,0.1);
  border-radius: 16px 16px 16px 16px;
  opacity: 1;
  border: 1px solid #B6352C;
  .el-input__inner{
    border: none;
    height: 100%;
    border-radius: 16px;
  }
}
</style>